import React from 'react';
import { useTranslation } from 'react-i18next';
import { sendCustomTrackingInfo } from '@panel/commons';
import { formatNumberCurrency } from '@panel/commons/helpers/formatAmount';
import { site as currentSite } from '@panel/commons/helpers/siteUtils';
import { totalCurrencies } from '@panel/commons/helpers/currenciesBySite';
import { getNameColor } from '../../helpers/getPlansInformation';
import { CardWrapper, HeaderCard, PriceWrapper, CheckInfo, RowCheck, CTA, Icon, Tag } from './styles';
import arrowIcon from '../../assets/icons/rightArrowIcon.svg';
import checkIcon from '../../assets/icons/checkIcon.svg';

const PlanCard = ({
  device,
  site,
  idProducto,
  nameCard,
  priceCard,
  priceCardWithTaxes,
  currency,
  postPrice,
  description,
  note,
  noteTaxes,
  type,
  tag,
  position
}) => {
  const { t } = useTranslation();
  const redirect = linkId => `${window.location.origin}/publica-tu-propiedad/zonademand/${linkId}`;
  const formattedPrice = formatNumberCurrency(priceCard, currency);
  const formattedPriceWithTaxes = `${totalCurrencies[currency]}${priceCardWithTaxes}`;
  const displayPrice = currentSite.isArgentina && formattedPriceWithTaxes ? formattedPriceWithTaxes : formattedPrice;
  const displayNoteTaxes = currentSite.isArgentina ? `${noteTaxes}:${formattedPrice}` : noteTaxes;
  return (
    <CardWrapper data-panel='cardContainter' device={device} site={site}>
      <HeaderCard titleColor={getNameColor[type]}>
        <div className='title' data-panel={`landingZD-plansSection-card-title-${type}`}>
          {nameCard || t(`panel.landing_ZD.PlansSection.card.title.${type}`)}
        </div>
        {priceCard && (
          <div>
            <PriceWrapper>
              <div className='price' data-panel={`landingZD-plansSection-card-priceCard-${type}`}>
                {displayPrice || '-'}
              </div>
              <span data-panel={`landingZD-plansSection-card-postPrice-${type}`}>{postPrice || 'mes'}</span>
            </PriceWrapper>
            {note && (
              <div className='text-info' data-panel={`landingZD-plansSection-card-note-${type}`}>
                {note}
              </div>
            )}
          </div>
        )}
      </HeaderCard>
      <CheckInfo>
        {description &&
          description.map((checkInfo, index) => (
            <RowCheck key={checkInfo + 1}>
              <Icon
                data-panel={`landingZD-plansSection-card-icon-${type}-${index}`}
                width='10px'
                height='7px'
                icon={arrowIcon}
                mTop='4px'
              />
              <p
                className='text-item'
                title={checkInfo.replace('Nordelta y en Puerto Madero', 'tu Zona Demand')}
                data-panel={`landingZD-plansSection-card-check-${type}-${index}`}
              >
                {checkInfo.replace('Nordelta y en Puerto Madero', 'tu Zona Demand')}
              </p>
            </RowCheck>
          ))}
        {noteTaxes && (
          <p className='iva-info' data-panel={`landingZD-plansSection-card-ivaInfo-${type}`}>
            {displayNoteTaxes}
          </p>
        )}
      </CheckInfo>
      <CTA
        data-panel={`landingZD-plansSection-card-cta-${type}`}
        onClick={() => {
          window.open(redirect(idProducto), '_blank');
          sendCustomTrackingInfo({
            event: 'productClick',
            ecommerce: {
              flow_type: 'Profesional',
              click: {
                products: [
                  {
                    id: idProducto,
                    name: nameCard.replace('1 ', ''),
                    price: formattedPrice,
                    category: 'Aviso Profesionales',
                    position: position + 1,
                    list: 'Listado landing Zona Demand'
                  }
                ]
              }
            }
          });
        }}
      >
        {t('panel.landing_ZD.PlansSection.card.cta')}
        <Icon width='21px' height='21px' icon={checkIcon} mBottom='2px' />
      </CTA>
      {tag && (
        <Tag data-panel={`landingZD-plansSection-card-tag-${type}`} color={getNameColor[type]}>
          {t('panel.landing_ZD.PlansSection.card.tag')}
        </Tag>
      )}
    </CardWrapper>
  );
};

export default PlanCard;
